import React from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default function useRecaptchaToken() {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleReCaptchaVerify = React.useCallback(async () => {
    let token = '';
    if (executeRecaptcha) {
      token = await executeRecaptcha();
    }

    return token;
  }, [executeRecaptcha]);

  return handleReCaptchaVerify;
}
